<template>
    <div class="my-shops">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <p class="my-shops__title d-flex align-items-center">
                        <span>My Shops</span> <span>&#8226;</span> <span v-if="myShops && myShops.length">{{myShops.length}}</span>
                    </p>
                </div>
                <div class="col-12">
                    <ShopsList v-if="myShops && myShops.length" :list="myShops" location="My Shops" size = "medium"/>
                    <div v-else class="my-shops__wrapper-emptystate">
                        <EmptyState
                            image="publish-empty-state"
                            title="No shops found"
                            description="Try different search filters."
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, computed } from '@vue/composition-api'
import Shop from '../../components/Ecommerce/Shops/Shop'
import EmptyState from '../../components/Ecommerce/EmptyState'
import { useRouter, useStore} from '../../core/hooks'
import ShopsList from '../../components/Ecommerce/Shops/ShopsList'
import { message } from 'ant-design-vue'
export default {
    name: 'MyShops',
    components: {
        Shop,
        ShopsList,
        EmptyState
    },
    setup: function() {
        const {state} = useStore()
        const {router} = useRouter()
        const myShops = computed(() => state.value.myShops)

        console.log(myShops.value)

        onMounted(() => {
            if(!myShops.value.length){
                message.info("You haven't added a shop yet. Use our wizard to add your shop via URL.", 5)
                return router.push('/add-shop')
            }
        })

        return {
            myShops
        }
    }
}
</script>

<style lang="scss" scoped>
.my-shops {
    padding: 40px 0;
    &__wrapper-emptystate {
        display: flex;
        min-height: calc(100vh - 285px);
        justify-content: center;
        align-items: center;
    }
    &__title {
        margin-bottom: 20px;
        span {
            font-size: 20px;
            font-family: 'Eina Bold';
            line-height: 32px;
            color: #333333;
            &:nth-child(2) {
                margin: 0 8px;
            }
        }
    }
    &__card-container {
        margin-bottom: 24px;
    }
}
</style>